
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`So hilft die «SwissCovid» App beim Contact-Tracing`}</h1>
    <h2>{`Wie kann man ansteckende Personen früh genug isolieren? Die App des Bundes soll vom 25. Juni an die Verfolgung der Übertragungsketten unterstützen – in unserer interaktiven Erklärung zeigen wir, warum Proximity Tracing Sinn macht.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;